import React, { useState, useEffect } from 'react';

const PostModal = ({ onSubmit, onClose, initialData, username, userArea }) => {
  const [formData, setFormData] = useState({
    fecha: '',
    obra: '',
    descripcion: '',
    costo: '',
    usuario: username,
    area: userArea,
    percentage: 0,
    state: 'Selecciona una opción',
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        ...initialData,
        usuario: initialData.usuario || username,
        area: initialData.area || userArea,
      });
    } else {
      setFormData({
        fecha: '',
        obra: '',
        descripcion: '',
        costo: '',
        usuario: username,
        area: userArea,
        percentage: 0,
        state: 'Selecciona una opción',
      });
    }
  }, [initialData, username, userArea]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.state === 'Selecciona una opción') {
      alert('Por favor, selecciona un estado válido.');
      return;
    }
    onSubmit(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{initialData ? 'Editar Publicación' : 'Nueva Publicación'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="fecha">Fecha:</label>
            <input
              type="date"
              id="fecha"
              value={formData.fecha}
              onChange={(e) => setFormData({ ...formData, fecha: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="obra">Proyecto:</label>
            <input
              type="text"
              id="obra"
              value={formData.obra}
              onChange={(e) => setFormData({ ...formData, obra: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="descripcion">Descripción:</label>
            <textarea
              id="descripcion"
              value={formData.descripcion}
              onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
              required
              rows={4}
            />
          </div>
          <div className="form-group">
            <label htmlFor="costo">Inversión Total:</label>
            <input
              type="number"
              id="costo"
              step="0.01"
              value={formData.costo}
              onChange={(e) => setFormData({ ...formData, costo: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="state">Estado:</label>
            <select
              id="state"
              value={formData.state}
              onChange={(e) => setFormData({ ...formData, state: e.target.value })}
              required
            >
              <option value="Selecciona una opción" disabled>Selecciona una opción</option>
              <option value="Finalizado">Finalizado</option>
              <option value="En proceso">En proceso</option>
              <option value="A iniciar">A iniciar</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="percentage">
              Porcentaje: <span className="percentage-value">{formData.percentage}%</span>
            </label>
            <input
              type="range"
              id="percentage"
              min="0"
              max="100"
              value={formData.percentage}
              onChange={(e) => setFormData({ ...formData, percentage: Number(e.target.value) })}
              style={{
                background: `linear-gradient(to right, var(--primary-color) 0%, var(--primary-color) ${formData.percentage}%, #d3d3d3 ${formData.percentage}%, #d3d3d3 100%)`
              }}
            />
          </div>
          <div className="modal-buttons">
            <button type="button" onClick={onClose}>Cancelar</button>
            <button type="submit">{initialData ? 'Actualizar' : 'Crear'}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PostModal;

